export default "__VITE_ASSET__RsfjXpEd__"